import { isAsync } from './isAsync';
import { Observable } from 'rxjs';

export class Certificate {
  _cert: any;
  name?: string;
  label?: string;
  thumbprint: string;
  subjectName: string;
  issuerName: string;
  validFrom: string;
  validTo: string;
  provider: Observable<string>;
  privateKeyLink: Observable<string>;
  serialNumber: string;
  algorithm: Observable<string>;
  isStore: boolean;
  isValid: Observable<boolean>;

  constructor(item) {
    this._cert = item._cert;
    this.thumbprint = item.thumbprint;
    this.subjectName = item.subjectName;
    this.issuerName = item.issuerName;
    this.validFrom = item.validFrom;
    this.validTo = item.validTo;
    this.serialNumber = item.serialNumber;
    this.provider = item.provider;
    this.privateKeyLink = item.privateKeyLink;
    this.algorithm = item.algorithm;
    this.isStore = item.isStore;
    this.isValid = item.isValid;
  }

  /**
   * Возвращает информацию об алгоритме сертификата
   */
  getAlgorithm(): Promise<{
    algorithm: string;
    oid: string;
  }> {
    return new Promise((resolve, reject) => {
      let result;
      let algorithm;

      try {
        if (isAsync()) {
          (async () => {
            algorithm = await this._cert.PublicKey();
            algorithm = await algorithm.Algorithm;

            result = {
              algorithm: await algorithm.FriendlyName,
              oid: await algorithm.Value,
            };
            resolve(result);
          })();
        } else {
          algorithm = this._cert.PublicKey();
          algorithm = algorithm.Algorithm;

          result = {
            algorithm: algorithm.FriendlyName,
            oid: algorithm.Value,
          };
          resolve(result);
        }
      } catch (err) {
        reject('Ошибка при получении алгоритма: ' + err.message);
      }
    });
  }
}

// var cryptoCommon = cryptoCommon || common;
// var Certificate = Certificate || function (item) {
//     this._cert = item._cert;
//     this.thumbprint = item.thumbprint;
//     this.subjectName = item.subjectName;
//     this.issuerName = item.issuerName;
//     this.validFrom = item.validFrom;
//     this.validTo = item.validTo;
// };
//
// /**
//  * Достает указанное свойство у сертификата
//  * */
// Certificate.prototype.getProp = function (propName) {
//     var cert = this._cert;
//
//     return new Promise(function (resolve, reject) {
//         eval(cryptoCommon.generateAsyncFn(function getProp() {
//             var result;
//
//             try {
//                 result = 'yield' + cert[propName];
//             } catch (err) {
//                 reject('Ошибка при обращении к свойству сертификата: ', err.message);
//                 return;
//             }
//
//             resolve(result);
//         }));
//     });
// };
//
// /**
//  * Экспорт base64 представления сертификата пользователя
//  * */
// Certificate.prototype.exportBase64 = function exportBase64() {
//     var cert = this._cert;
//
//     return new Promise(function (resolve, reject) {
//         eval(cryptoCommon.generateAsyncFn(function exportBase64() {
//             var base64;
//
//             try {
//                 base64 = 'yield' + cert.Export(0);
//             } catch (err) {
//                 reject('Ошибка при экспорте сертификата: ', err.message);
//                 return;
//             }
//
//             resolve(base64);
//         }));
//     });
// };
//
// /**
//  * Возвращает информацию об алгоритме
//  * */
// Certificate.prototype.getAlgorithm = function getAlgorithm() {
//     var cert = this._cert;
//
//     return new Promise(function (resolve, reject) {
//         eval(cryptoCommon.generateAsyncFn(function getAlgorithm() {
//             var result = {},
//                 algorithm;
//
//             try {
//                 algorithm = 'yield' + cert.PublicKey();
//                 algorithm = 'yield' + algorithm.Algorithm;
//
//                 result.algorithm = 'yield' + algorithm.FriendlyName;
//                 result.oid = 'yield' + algorithm.Value;
//             } catch (err) {
//                 reject('Ошибка при получении алгоритма: ', err.message);
//                 return;
//             }
//
//             resolve(result);
//         }));
//     });
// };
//
// /**
//  * Разбирает SubjectName сертификата по тэгам
//  * */
// Certificate.prototype.getOwnerInfo = function getOwnerInfo() {
//     return getCertInfo.call(this, cryptoCommon.subjectNameTagsTranslations, 'SubjectName');
// };
//
// /**
//  * Разбирает IssuerName сертификата по тэгам
//  * */
// Certificate.prototype.getIssuerInfo = function getIssuerInfo() {
//     return getCertInfo.call(this, cryptoCommon.issuerNameTagsTranslations, 'IssuerName');
// };
//
// /**
//  * Получение OID сертификата
//  *
//  * @returns {Array} Возвращает массив OID (улучшенного ключа)
//  * */
// Certificate.prototype.getExtendedKeyUsage = function getExtendedKeyUsage() {
//     var cert = this._cert;
//
//     return new Promise(function (resolve, reject) {
//         eval(cryptoCommon.generateAsyncFn(function getExtendedKeyUsage() {
//             var OIDS = [],
//                 count,
//                 item;
//
//             try {
//                 count = 'yield' + cert.ExtendedKeyUsage();
//                 count = 'yield' + count.EKUs;
//                 count = 'yield' + count.Count;
//
//                 if (count > 0) {
//                     while (count > 0) {
//                         item = 'yield' + cert.ExtendedKeyUsage();
//                         item = 'yield' + item.EKUs;
//                         item = 'yield' + item.Item(count);
//                         item = 'yield' + item.OID;
//
//                         OIDS.push(item);
//
//                         count--;
//                     }
//                 }
//             } catch (err) {
//                 reject('Ошибка при получении ОИД\'ов: ', err.message);
//                 return;
//             }
//
//             resolve(OIDS);
//         }));
//     });
// };
//
// Certificate.prototype.getDecodedExtendedKeyUsage = cryptoCommon.getDecodedExtendedKeyUsage;
//
// Certificate.prototype.hasExtendedKeyUsage = cryptoCommon.hasExtendedKeyUsage;



// WEBPACK FOOTER //
// ./src/app/utils/certificate.ts